import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

import "./index.css";
import { initTheme } from "./lib/theme";

initTheme();

const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    sendDefaultPii: false,
  });
}

// Timeout/soluço de infra (ex.: deploy em andamento) não pode deixar tela morta —
// erro de load de rota vira mensagem amigável com botão de recarregar.
const router = createRouter({
  routeTree,
  defaultErrorComponent: ({ error }) => (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 12, background: "var(--surface-app)" }}>
      <span style={{ fontSize: 15, fontWeight: 600, color: "var(--ink)" }}>Não foi possível carregar</span>
      <span style={{ fontSize: 13, color: "var(--ink-muted)", maxWidth: 420, textAlign: "center" }}>
        {error instanceof Error && error.name === "TimeoutError"
          ? "O servidor demorou para responder — pode ser um deploy em andamento. Tente de novo em instantes."
          : String(error)}
      </span>
      <button
        onClick={() => window.location.reload()}
        style={{
          fontSize: 13, padding: "8px 18px", borderRadius: 8, cursor: "pointer",
          border: "1px solid var(--line-strong)", background: "var(--surface-hover)", color: "var(--ink)",
        }}
      >
        Tentar novamente
      </button>
    </div>
  ),
});

declare module "@tanstack/react-router" {
  interface Register { router: typeof router; }
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
